import { Link, useLocation } from 'react-router-dom';
import { 
  Home, 
  Briefcase, // Changé de Services à Briefcase
  Image, 
  Users, 
  Mail, 
  DollarSign, 
  FileText, 
  BarChart3,
  Settings,
  LogOut
} from 'lucide-react';
import { authAPI } from '../../api/auth';

const menuItems = [
  { icon: <Home size={20} />, label: 'Dashboard', path: '/admin/dashboard' },
  { icon: <Briefcase size={20} />, label: 'Services', path: '/admin/services' }, // Changé ici
  { icon: <Image size={20} />, label: 'Modèles', path: '/admin/models' },
  { icon: <Users size={20} />, label: 'Clients', path: '/admin/clients' },
  { icon: <Mail size={20} />, label: 'Contacts', path: '/admin/contacts' },
  { icon: <DollarSign size={20} />, label: 'Tarifs', path: '/admin/pricing' },
  { icon: <FileText size={20} />, label: 'Devis', path: '/admin/quotes' },
  { icon: <BarChart3 size={20} />, label: 'Statistiques', path: '/admin/stats' },
  { icon: <Settings size={20} />, label: 'Paramètres', path: '/admin/settings' },
];

export default function AdminSidebar() {
  const location = useLocation();
  
  const handleLogout = () => {
    authAPI.logout();
    window.location.href = '/admin/login';
  };
  
  return (
    <div className="admin-sidebar">
      <div className="sidebar-header">
        <h3>DigitalPro Admin</h3>
      </div>
      
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
          >
            {item.icon}
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>
      
      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-btn">
          <LogOut size={20} />
          <span>Déconnexion</span>
        </button>
      </div>
    </div>
  );
}